import Toggle from "@/components/fields/Toggle";
import {useAppState} from "@/store";
import PropertyType from "@/components/fields/PropertyType";
import PropertySize from "@/components/fields/PropertySize";
import PropertyAddress from "@/components/fields/PropertyAddress";
import PropertyEntranceDistance from "@/components/fields/PropertyEntranceDistance";
import PropertyFloorNumber from "@/components/fields/PropertyFloorNumber";
import {
    PROPERTY_TYPES_WITH_ELEVATOR,
    PROPERTY_TYPES_WITH_FLOORS,
    PROPERTY_TYPES_WITH_SQFT,
    PROPERTY_TYPES_WITH_STORIES
} from "@/constants";
import PropertyStories from "@/components/fields/PropertyStories";
import PropertySqFt from "@/components/fields/PropertySqFt";
import InfoIcon from "@/components/icons/InfoIcon";

export default function PropertyDetails({stateKey}) {

    const {state, setState} = useAppState()

    const propertyType = state[stateKey]?.propertyType

    const showSize = (propertyType)
    const showFloorNumber = propertyType && PROPERTY_TYPES_WITH_FLOORS.includes(propertyType)
    const showStories = propertyType && PROPERTY_TYPES_WITH_STORIES.includes(propertyType)
    const showSqFt = propertyType && PROPERTY_TYPES_WITH_SQFT.includes(propertyType)
    const showElevator = propertyType && PROPERTY_TYPES_WITH_ELEVATOR.includes(propertyType)

    return (
        <>
            <PropertyAddress stateKey={stateKey} />
            {/*<PropertyZip stateKey={stateKey} />*/}
            <PropertyType stateKey={stateKey} />
            {showSize && <PropertySize stateKey={stateKey} />}
            {showSqFt && <PropertySqFt stateKey={stateKey} />}
            {showFloorNumber && <PropertyFloorNumber stateKey={stateKey} />}
            {showStories && <PropertyStories stateKey={stateKey} />}
            <PropertyEntranceDistance stateKey={stateKey} />
            {showElevator && (
                <div className={'grid grid-cols-2 gap-[32px]'}>
                    <div>
                        <Toggle
                            label={"Elevator"}
                            name={`${stateKey}.elevator`}
                            checked={state[stateKey]?.elevator || ''}
                            tooltipTitle={"Don’t get stuck on moving day!"}
                            tooltip={"If necessary, book your building’s elevator in advance! Otherwise, we’ll have to give your couch an in-depth tour of the stairwell. 😅"}
                            tooltipIcon={<InfoIcon className={"size-[16px]"} />}
                            onChange={checked => setState((s) => {s[stateKey].elevator = checked})}
                        />
                    </div>
                    <div>
                        <Toggle
                            label={"Stairs"}
                            name={`${stateKey}.stairs`}
                            checked={state[stateKey]?.stairs || ''}
                            onChange={checked => setState((s) => {s[stateKey].stairs = checked})}
                        />
                    </div>
                </div>
            )}
        </>
    )

}
